var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"piece piece-flower",style:({ 'grid-area': (_vm.y+1) + '/' + (_vm.x+1) })})}
var staticRenderFns = []

export { render, staticRenderFns }